
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import Map from '~/components/UI/Map'
import productData from '@/data/products.json'
export default {

  name: 'CourseInfo',
  components: {
    Map,
  },

  props: {
    city: {
      type: String,
      default: ''
    },
    cdata: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      locations: [],
      allLocations: [],
      zoom: 12,
      center: [-1.17432, 52.355518],
      cityCentre: null,
      city_name: '',
      showRow: null,
      url: '',
    }
  },
  head() {
    const list = this.structuredDataEvent
    if (list && list.itemListElement && list.itemListElement.length > 0) {
      return { script: [{ hid: 'location-events', type: 'application/ld+json', json: list }] }
    }
  },
  computed: {
    ...mapGetters({
      detectedRegion: 'geolocation/region',
      userRegion: 'user/region',
      priceLabel: 'cart/getPriceLabel',
      activeModal: 'pages/getActiveModal',
      classroomsFor: 'classrooms/forCity',
    }),
    // Derive view fields from the store data WITHOUT mutating the store records.
    classrooms() {
      const self = this
      const raw = this.$props.cdata || []
      // console.log('[PHYSICAL] city_name=[' + this.city_name + '] forCity_rows=' + raw.length)
      const out = raw.map(function (c) {
        const products = (c.products || []).map(function (p) {
          const pd = (p.prices && p.prices.length > 0)
            ? self.$options.filters.priceData(Object.assign({}, p))
            : null
          return Object.assign({}, p, {
            data: productData.filter(function (o) { return o.id === p.id }),
            priceData: pd,
            onSale: (pd && pd.saleType !== 'none') || false
          })
        })
        const places = (c.maxAttendees || 0) - (c.numAttendees || 0)
        return Object.assign({}, c, {
          places,
          availability: self.getAvailable(places),
          products
        })
      })
      return out
    },
    region() {
      return this.userRegion === 'default' ? this.detectedRegion : this.userRegion
    },
    regionToShow() {
      return this.$options.filters.regionToShow(this.region)
    },
    // FOR SCHEMA — build fresh objects; never write onto the derived classrooms.
    productsList() {
      const twoDay = []
      const threeDay = []
      const rooms = this.classrooms

      rooms.forEach((classroom) => {
        classroom.products.forEach((product) => {
          if (!(product.prices.length > 0 && product.id !== 2)) return

          const isTwoDay = classroom.length === 2 || classroom.length === '2'
          const bucket = isTwoDay ? twoDay : threeDay
          if (bucket.some((el) => el.id === product.id)) return

          const matched = rooms.filter((c) => {
            return isTwoDay
              ? (c.length === 2 || c.length === '2')
              : (c.length === 3 || c.length === '3')
          })
          bucket.push(Object.assign({}, product, { classrooms: matched }))
        })
      })

      return twoDay.concat(threeDay)
    },
    currency() {
      return this.$options.filters.currencyCodeFromLabel()
    },
    priceData() {
      const priceDataArray = []
      this.productsList.forEach((product) => {
        const priceD = this.$options.filters.priceData(product)
        priceDataArray.push(priceD)
      })
      return priceDataArray
    },
    prices() {
      const prices = []
      this.priceData.forEach((priceData) => {
        const price = this.$options.filters.priceFromLabelNumber(priceData.pricesDiscounted)
        prices.push(price)
      })
      return prices
    },
    structuredDataEvent() {
      const self = this

      // "EN" / "England" / "Scotland" ... -> "GB"; pass through real 2-letter codes
      function isoCountry(c) {
        if (!c) return 'GB'
        const v = String(c).trim().toUpperCase()
        const uk = ['EN', 'ENGLAND', 'SCOTLAND', 'WALES', 'NORTHERN IRELAND', 'NI', 'UK', 'GB', 'GBR']
        if (uk.includes(v)) return 'GB'
        return v.length === 2 ? v : 'GB'
      }

      const itemList = []

      this.classrooms.forEach(function (classroom) {
        // Bookable products only: has a price, and not the excluded placeholder (id 2)
        const bookable = (classroom.products || []).filter(function (p) {
          return p.prices && p.prices.length > 0 && p.id !== 2
        })
        if (bookable.length === 0) return

        const locality = self.getLocality(classroom)
        const dateText = self.getDateText(classroom)

        // One Offer per bundle — the same weekend sold with different online packages
        const offers = bookable.map(function (p) {
          const pData = productData.filter(function (o) { return o.id === p.id })
          const pUrl = (pData[0] && pData[0].page && pData[0].page.en)
            ? 'https://www.tefl.org' + pData[0].page.en.uri
            : 'https://www.tefl.org' + self.url
          return {
            '@type': 'Offer',
            'category': 'Paid',
            'name': p.name,
            'price': (p.prices[0] && p.prices[0].cost != null) ? p.prices[0].cost.toString() : undefined,
            'priceCurrency': self.currency,
            'availability': 'https://schema.org/LimitedAvailability',
            'url': pUrl,
            'validFrom': classroom.dateCreated
          }
        })

        itemList.push({
          '@type': 'Event',
          'name': locality + ' TEFL Course: ' + dateText,
          'url': 'https://www.tefl.org' + self.url,
          'image': self.$store.state.pages.page.thumbnail,
          'startDate': classroom.startDate,
          'endDate': classroom.endDate,
          'eventAttendanceMode': 'https://schema.org/OfflineEventAttendanceMode',
          'eventStatus': 'https://schema.org/EventScheduled',
          'description': 'TEFL courses in ' + locality + ' with The TEFL Org. The ' + locality +
            ' TEFL course gives you all the essential tools you need to be able to plan and prepare ' +
            'your own TEFL classes, no matter what size of class you may face. Our courses have been ' +
            'designed by highly qualified TEFL industry professionals with years of experience to ' +
            'ensure courses of the highest quality and up-to-date training.',
          offers,
          'location': {
            '@type': 'Place',
            'name': classroom.venue.name,
            'address': {
              '@type': 'PostalAddress',
              'streetAddress': classroom.venue.line1,
              'addressLocality': locality,
              'postalCode': classroom.venue.postcode,
              'addressCountry': isoCountry(classroom.venue.country)
            }
          },
          'organizer': {
            '@type': 'Organization',
            'name': 'The TEFL Org',
            'url': 'https://www.tefl.org/',
            'sameAs': 'https://www.tefl.org/'
          },
          'performer': {
            '@type': 'Organization',
            'name': 'The TEFL Org'
          }
        })
      })

      return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        'itemListElement': itemList,
        'name': 'TEFL Courses in ' + this.$options.filters.capitalise(this.city_name)
      }
    },
  },

  created() {
    const page = this.$store.state.pages.page || {}
    this.city_name = this.$props.city || page.geolocationCity || page.slug || ''
    this.url = page.uri || ''
  },

  async mounted() {
    // Map + geo is genuinely client-only; it reads (never writes) this.classrooms.
    const rooms = this.classrooms
    const locs = []
    for (let i = 0; i < rooms.length; i++) locs.push(rooms[i].venueId)
    const uniqueVenueIds = [...new Set(locs)]

    function unique(array, propertyName, name) {
      return array.filter(function (e, idx) {
        return array.findIndex(function (a) {
          return a[name][propertyName] === e[name][propertyName]
        }) === idx
      })
    }
    this.locations = unique(rooms, 'postcode', 'venue')

    try {
      const mapslocs = await axios.get(process.env.DATA_URL + '/classroom/locations')
      const maplocations = mapslocs.data.filter(function (venue) {
        return uniqueVenueIds.includes(venue.id)
      })
      for (let j = 0; j < maplocations.length; j++) {
        const s = this.locations.find(function (l) { return l.venueId === maplocations[j].id })
        if (s) Object.assign(maplocations[j], s)
      }
      if (maplocations.length > 0) {
        this.center = [maplocations[0].long, maplocations[0].lat]
        this.locations = maplocations
      }
    } catch (error) {
      console.log(error)
    }
  },

  methods: {
    ...mapActions({
      updateActiveModal: 'pages/updateActiveModal',
    }),
    updateModalFunc(name) {
      const hours = name.substring(0, 3).replaceAll('-', '')
      const id = hours + 'includedtable'
      this.updateActiveModal(id)
      console.log('Active ID: ', id)
    },
    updateModal(id) {
      this.updateActiveModal(id)
      console.log('Active Modal: ', this.activeModal)
    },
    hideModal() {
      this.updateActiveModal(null)
      console.log('Active Modal: ', this.activeModal)
    },
    showOption(index) {
      console.log(index)
      if (index === this.showRow) {
        this.showRow = null
      } else {
        this.showRow = index
      }
      this.$nextTick(() => {
        const element = document.getElementById('class' + index)
        element.scrollIntoView({
          behavior: 'smooth',
        })
      })
    },
    getLocality(classroom) {
      return classroom.venue.city ? classroom.venue.city : classroom.venue.town
    },
    getAvailable(places) {
      if (places <= 1) return 'low'
      if (places >= 2 && places <= 8) return 'medium'
      return 'good'
    },
    getDateText(classroom) {
      let dateText
      // Get the two digits representing the DAY
      const startSlug = classroom.startDate.slice(-2)
      const endSlug = classroom.endDate.slice(-2)

      // Get the two digits representing the MONTH
      const startMonthSlug = classroom.startDate.slice(5, 2)
      const endMonthSlug = classroom.startDate.slice(5, 2)

      // Get the name of the start month
      const date = new Date(classroom.startDate)
      const month = date.toLocaleString('default', { month: 'long' })

      // If it starts and ends in the same month
      if (startMonthSlug === endMonthSlug) {
        dateText = startSlug + '-' + endSlug + ' ' + month
      } else {
        const dateTwo = new Date(classroom.endDate)
        const monthTwo = dateTwo.toLocaleString('default', { month: 'short' })
        dateText = startSlug + ' ' + monthTwo + '-' + endSlug + ' ' + month
      }
      return dateText
    }
  },
}
